export const NAME = "name";
export const INVENTORY_NAMES = "inventoryNames";
export const DESCRIPTION = "description";
export const KIT = "kitId";
export const KIT_TYPE = "kitType";
